import React, { useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import revenueIcon from '../images/revenueIcon.jpg';
import contractAwardIcon from '../images/Icon-Contract-Awards.png';
import globeIcon from '../images/globeIcon.jpg';
import corporateHQImage from '../images/006 LepoldPhotography-CACI-HQ.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import CounterAnimation from '../components/CounterAnimation';
import './Pages.css';

export default function OurApproach() {

  localStorage.setItem('activeLinkIndex', '4');
  const navigate = useNavigate();
  const leftArrowRef = useRef(null);
  const rightArrowRef = useRef(null);

  return (
    <>
    <div className='main-container'>
      <Container>
        {/* Content Area */}
        <div className='contentArea flex'>
          {/* Header */}
          <Row className='headerRow'>
            <h1 data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>Our approach</h1>
          </Row>
          <hr/>
          <Row className='pb-5 gx-5'>
            <Col lg={6}>
              <p className='callOutParagraph' data-aos='zoom-in' data-aos-duration='750' data-aos-once='true' >The ability to execute our mission is rooted in our strong corporate responsibility to our employees, customers, and shareholders.</p>
              <br/>
              <p>By focusing on our people, our planet, and our governance policies, we deliver positive outcomes when and where it matters most.</p>
              <p>As our ESG initiatives grow, so too will our ESG strategy, and we look forward to communicating these updates and improvements in the future.</p>
              <br/>
              {/* Statistics */}
              <div className='stat'>
                <div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
                  <img alt='An icon of a stock chart.' src={revenueIcon} style={{width: '75%'}}/>
                </div>
                <div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight'>
                  <span className="infographicHeading">$<CounterAnimation targetNumber={8.6} />B</span>
                  <br/>
                  <span className='infographicSubHeading'>FY 2025 revenue</span>
                </div>
              </div>
              <div className='stat'>
                <div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
                  <img alt='An icon of a US Map.' src={contractAwardIcon} style={{width: '75%'}}/>
                </div>
                <div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight'>
                  <span className="infographicHeading">$<CounterAnimation targetNumber={10} />B</span>
                  <br/>
                  <span className='infographicSubHeading'>in contract awards</span>
                </div>
              </div>
              <div className='stat'>
                <div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
                  <img alt='An icon of a globe.' src={globeIcon} style={{width: '75%'}}/>
                </div>
                <div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight'>
                  <span className="infographicHeading"><CounterAnimation targetNumber={159} /></span>
                  <br/>
                  <span className='infographicSubHeading'>locations globally</span>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <img alt='CACI International Inc. headquarters.' data-aos='fade-right' data-aos-duration='750' data-aos-once='true' src={corporateHQImage} style={{width: '100%'}} />
            </Col>
          </Row>
        </div>
      </Container>
    </div>
          <div className='navigationArrows'>
        <div ref={leftArrowRef} className='arrowContainer leftArrow' 
onTouchStart={() => {
                    leftArrowRef.current.classList.add('arrowTouchActive');
                }}
            onTouchEnd={() => {
                    leftArrowRef.current.classList.remove('arrowTouchActive');
                }} onClick={() => {
              navigate('/fy2025-awards-and-recognition');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[3].classList.add('active');
              document.getElementsByClassName('underline')[3].classList.add('active');
            }}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </div>
        <div ref={rightArrowRef} className='arrowContainer rightArrow'
        onTouchStart={() => {
                    rightArrowRef.current.classList.add('arrowTouchActive');
                }}
            onTouchEnd={() => {
                    rightArrowRef.current.classList.remove('arrowTouchActive');
                }}  onClick={() => {
              navigate('/environment');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[5].classList.add('active');
              document.getElementsByClassName('underline')[5].classList.add('active');
            }}>
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </div>
    </>
  );
}
